var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoreHorizontal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 4,
    viewBox: "0 0 16 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 2.00004C0.5 1.08337 1.25 0.333374 2.16667 0.333374C3.08333 0.333374 3.83333 1.08337 3.83333 2.00004C3.83333 2.91671 3.08333 3.66671 2.16667 3.66671C1.25 3.66671 0.5 2.91671 0.5 2.00004ZM9.66667 2.00004C9.66667 2.91671 8.91667 3.66671 8 3.66671C7.08333 3.66671 6.33333 2.91671 6.33333 2.00004C6.33333 1.08337 7.08333 0.333374 8 0.333374C8.91667 0.333374 9.66667 1.08337 9.66667 2.00004ZM13.8333 0.333374C12.9167 0.333374 12.1667 1.08337 12.1667 2.00004C12.1667 2.91671 12.9167 3.66671 13.8333 3.66671C14.75 3.66671 15.5 2.91671 15.5 2.00004C15.5 1.08337 14.75 0.333374 13.8333 0.333374Z",
    fill: "#515151"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreHorizontal);
export default __webpack_public_path__ + "static/media/more-horizontal.54e6defb80e4bc3c3ef94f321ddae7ea.svg";
export { ForwardRef as ReactComponent };